import { createStorefrontClient } from '@template-project/storefront-bff-client';
import { IOrderService, RefundOrderRequest } from '../../domain/services/order.service.interface';
import { Order, OrderListResponse } from '../../domain/entities/order.entity';
import { env } from '@/lib/utils/env';

export class OrderService implements IOrderService {
  private get client() {
    return createStorefrontClient({
      baseUrl: env.STOREFRONT_BFF_URL,
      tenantId: env.FUNNELS_TENANT_ID,
    });
  }

  async getOrdersByUserID(userID: string, page = 1, limit = 10): Promise<OrderListResponse> {
    const res = await this.client.listOrders({ user_id: userID, page, limit });
    return { data: res.data as Order[], pagination: res.meta.pagination };
  }

  async getOrdersByEmail(email: string, page = 1, limit = 10): Promise<OrderListResponse> {
    const res = await this.client.listOrders({ email, page, limit });
    return { data: res.data as Order[], pagination: res.meta.pagination };
  }

  async getOrderById(orderId: string): Promise<Order> {
    const res = await this.client.getOrder(orderId);
    return res.data as Order;
  }

  async refundOrder(orderId: string, request: RefundOrderRequest): Promise<unknown> {
    const res = await this.client.refundOrder(orderId, request);
    return res.data;
  }
}

let orderServiceInstance: OrderService | null = null;

export function getOrderService(): OrderService {
  orderServiceInstance ??= new OrderService();
  return orderServiceInstance;
}
